import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { ILatestArticlesProps } from '../components/latest-articles/latest-articles';
import { ISectionHeaderProps } from '../components/section-header/section-header';
import { SectionHeaderModel } from './section-header-model';
import { IButtonProps } from '../components/button/button';
import { ButtonModel } from './button-model';
import { BlogArticleModel } from './blog-article.model';

export class LatestArticlesModel extends ContentItem {
  get articles(): [] {
    const nodes = get(this._config, 'latestArticles', []);
    const modeledArticles = nodes.map((article: IBlogArticle) =>
      BlogArticleModel.create(article as IBlogArticle)
    );

    return modeledArticles;
  }

  get id(): string {
    return get(this._config, 'elements.unique_id.value', '');
  }

  get header(): ISectionHeaderProps {
    const getHeader = get(this._config, 'elements.header.value[0]', null);

    const transformHeader = getHeader
      ? SectionHeaderModel.create(getHeader)
      : null;
    return transformHeader as ISectionHeaderProps;
  }

  get seeMoreButton(): IButtonProps {
    const getSeeMoreButton = get(
      this._config,
      'elements.see_more_button.value[0]',
      null
    );

    const transformButton = getSeeMoreButton
      ? ButtonModel.create(getSeeMoreButton)
      : null;
    return transformButton as IButtonProps;
  }

  get additionamMarginInRow(): string {
    return get(
      this._config,
      'elements.additional_margin__additional_margin_in_row.value[0].codename',
      ''
    );
  }
  get additionamMarginInColumn(): string {
    return get(
      this._config,
      'elements.additional_margin__additional_margin_in_column.value[0].codename',
      ''
    );
  }
  get backgroundColor(): string {
    return get(
      this._config,
      'elements.background_color_snippet__background_color.value[0].codename',
      ''
    );
  }

  public static create(data: ILatestArticles): ILatestArticlesProps {
    const {
      articles,
      header,
      seeMoreButton,
      additionamMarginInColumn,
      additionamMarginInRow,
      backgroundColor,
      id
    } = new LatestArticlesModel(data);
    return {
      articles,
      header,
      seeMoreButton,
      additionamMarginInColumn,
      additionamMarginInRow,
      backgroundColor,
      id
    };
  }
}
